/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-31 14:02:18
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-03-31 14:03:05
 * @FilePath: /unifyxp-v2-store-portal/src/router/SalesChannelEditorRoutes copy/index.ts
 */

import SalesChannelProductsLayout from '@/src/layout/SalesChannelProductsLayout';

import { IRoutes } from 'src/types/router';

import routes from 'src/config/routerConfig/salesChannelProducts';

const route: IRoutes = {
  layout: SalesChannelProductsLayout,
  subRoutes: routes,
};
export default route;
